import { render, staticRenderFns } from "./PersonIndex.vue?vue&type=template&id=79bbd7cc&scoped=true"
import script from "./PersonIndex.vue?vue&type=script&lang=js"
export * from "./PersonIndex.vue?vue&type=script&lang=js"
import style0 from "./PersonIndex.vue?vue&type=style&index=0&id=79bbd7cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bbd7cc",
  null
  
)

export default component.exports